__webpack_require__.p = "/moving-assistant/";